import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommClipboardTextIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M7.24805 11C7.24805 10.5858 7.58383 10.25 7.99805 10.25H15.998C16.4123 10.25 16.748 10.5858 16.748 11C16.748 11.4142 16.4123 11.75 15.998 11.75H7.99805C7.58383 11.75 7.24805 11.4142 7.24805 11ZM7.24805 16C7.24805 15.5858 7.58383 15.25 7.99805 15.25H11.998C12.4123 15.25 12.748 15.5858 12.748 16C12.748 16.4142 12.4123 16.75 11.998 16.75H7.99805C7.58383 16.75 7.24805 16.4142 7.24805 16Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M19.0868 4.89236C18.6759 4.48101 18.037 4.29668 16.4697 4.24966L16.5147 2.75034C18.059 2.79667 19.2753 2.95867 20.148 3.83219C20.7498 4.43454 21.0086 5.1929 21.1296 6.09364C21.2461 6.96133 21.2461 8.06461 21.2461 9.43356V16.0492C21.2461 17.4182 21.2461 18.5215 21.1296 19.3891C21.0086 20.2899 20.7498 21.0482 20.148 21.6506C19.5461 22.253 18.7882 22.5122 17.8879 22.6334C17.0209 22.75 15.9186 22.75 14.551 22.75L9.44122 22.75C8.07365 22.75 6.97127 22.75 6.10425 22.6334C5.20402 22.5122 4.44609 22.253 3.8442 21.6506C3.24241 21.0482 2.98359 20.2899 2.86261 19.3891C2.74606 18.5215 2.74607 17.4182 2.74609 16.0492L2.74609 9.43353C2.74607 8.06459 2.74606 6.96132 2.86261 6.09364C2.98359 5.1929 3.2424 4.43454 3.8442 3.83219C4.71691 2.95867 5.93319 2.79667 7.47751 2.75034L7.52249 4.24966C5.95521 4.29668 5.31632 4.48101 4.90535 4.89236C4.62846 5.1695 4.44794 5.55866 4.34925 6.29333C4.24768 7.04949 4.24609 8.05165 4.24609 9.48836L4.2461 15.9944C4.2461 17.4311 4.24769 18.4333 4.34925 19.1894C4.44794 19.9241 4.62846 20.3133 4.90535 20.5904C5.18214 20.8675 5.57066 21.048 6.30431 21.1468C7.0596 21.2484 8.06066 21.25 9.49609 21.25L14.4961 21.25C15.9315 21.25 16.9326 21.2484 17.6879 21.1468C18.4215 21.048 18.81 20.8675 19.0868 20.5904C19.3637 20.3133 19.5443 19.9241 19.6429 19.1894C19.7445 18.4333 19.7461 17.4311 19.7461 15.9944V9.48836C19.7461 8.05165 19.7445 7.04949 19.6429 6.29333C19.5443 5.55866 19.3637 5.1695 19.0868 4.89236Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M6.7461 3.75C6.7461 2.36929 7.86538 1.25 9.2461 1.25H14.7461C16.1268 1.25 17.2461 2.36929 17.2461 3.75C17.2461 5.13071 16.1268 6.25 14.7461 6.25H9.24609C7.86538 6.25 6.7461 5.13071 6.7461 3.75ZM9.2461 2.75C8.69381 2.75 8.2461 3.19772 8.2461 3.75C8.2461 4.30228 8.69381 4.75 9.24609 4.75H14.7461C15.2984 4.75 15.7461 4.30228 15.7461 3.75C15.7461 3.19772 15.2984 2.75 14.7461 2.75H9.2461Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
